import {Module} from 'vuex';
import {ChatPrompt, FriendState} from './types';
import {mutations} from '@/store/Friends/mutations';
import {actions} from '@/store/Friends/actions';
import {RootState} from '@/store/types';
import {getters} from '@/store/Friends/getters';

const state: FriendState = {
  friends: undefined,
  messages: undefined,
  currentlyChattingWith: undefined,
  meetups: undefined,
  chatPrompts: undefined,
  connections: undefined,
  transactions: undefined,
  connectionRequests: undefined,
  toConnections: undefined,
  senderConnections: undefined,
};
const namespaced: boolean = true;

export const friendState: Module<FriendState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
